import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_select = _resolveComponent("v-select")

  return (_openBlock(), _createBlock(_component_v_select, {
    class: "mb-6",
    items: $options.fontFamilyList,
    "model-value": $props.selectedFont,
    "item-title": "value",
    "item-value": "id",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = (newValue) => _ctx.$emit('update:modelValue', newValue)),
    variant: "outlined",
    density: "comfortable"
  }, null, 8, ["items", "model-value"]))
}